module.exports = __webpack_public_path__ + "img/pin-in-9.eb26111e.svg";